<template>
    <div class="course-view">
        <VodPlayer v-if="!isBought" :vimeoURL="course.preview_url" />
        <div class="course-header">
            <div class="course-description">
                <h2 class="title" v-html="course.title" />
                <p class="desc" v-html="course.description" />
                <p
                    v-if="!isBought"
                    class="course-details"
                    v-html="course.product_details"
                />
            </div>
            <div v-if="!isBought && !isMobile">
                <div
                    class="webinar-certificate-button"
                    @click="paymentVisible = true"
                >
                    <i class="material-icons">credit_card</i>
                    <div v-html="`ZDOBĄDŹ <b>PEŁNY DOSTĘP</b>`" />
                </div>
                <div class="webinar-button-subtitle">
                    Do e-szkolenia i zaświadczenia
                </div>
            </div>
        </div>
        <div v-if="isMobile" class="has-border-bottom"></div>
        <CourseModules
            @getCertificate="getCertificate"
            :isBought="isBought"
            :course="course"
        />
        <div v-if="isMobile" class="has-border-bottom"></div>
        <WebinarHost :content="course" />
        <div v-if="!isBought && isMobile" class="button-container">
            <Button
                :title="
                    isBought ? 'Pobierz zaświadczenie' : 'Zdobądź pełny dostęp'
                "
                :disabled="!courseFinished && isBought"
                @click="!isBought ? (paymentVisible = true) : getCertificate()"
            />
            <div class="webinar-button-subtitle">
                Do kursu i zaświadczenia
            </div>
        </div>
        <transition name="fade">
            <Modal
                ref="modal"
                @close="closePayment"
                v-if="paymentVisible && !isBought"
            >
                <VodCertificatePayment
                    @logged="checkUser"
                    @scrollTop="scrollTop"
                    :webinar="course"
                />
            </Modal>
            <Modal
                ref="modal"
                @close="closeCertificate"
                v-if="certificateVisible"
            >
                <VodCertificate
                    @close="closeCertificate"
                    @scrollTop="scrollTop"
                    :webinar="course"
                />
            </Modal>
        </transition>
    </div>
</template>
<script>
export default {
    components: {
        CourseModules: () => import('./CourseModules'),
        VodCertificatePayment: () => import('../VodCertificatePayment'),
        WebinarHost: () => import('../WebinarHost'),
        VodCertificate: () => import('../VodCertificate')
    },
    data() {
        return {
            paymentVisible: false,
            certificateVisible: false
        }
    },
    computed: {
        course() {
            const courseId = this.$route.params.uuid
            return this.$store.getters['content/productByUUID'](courseId)
        },
        isBought() {
            const boughtItems = this.$store.state.boughtItems
            return boughtItems.some(item => item.uuid == this.course.uuid)
        },
        isMobile() {
            return this.$store.getters['source/isMobile']
        },
        courseFinished() {
            const finishedExams = this.$store.state.roleStorage.finishedExams
            const courseModules = this.course.modules.map(module => {
                return {
                    id: module.id,
                    key: `${this.course.uuid}-${module.id}`
                }
            })
            return courseModules.every(module => {
                return finishedExams && finishedExams[module.key]
            })
        }
    },
    methods: {
        closeCertificate() {
            this.certificateVisible = false
        },
        getCertificate() {
            this.certificateVisible = true
        },
        checkUser() {
            this.paymentVisible = !this.isBought
        },
        scrollTop() {
            this.$refs.modal.scrollTop()
        },
        closePayment() {
            this.paymentVisible = false
        }
    },
    mounted() {
        if (this.$route.query.transaction) {
            this.paymentVisible = true
            this.$query.removeQuery('transaction')
        }
    }
}
</script>
<style lang="scss" scoped>
h2 {
    font-size: 3rem;
    margin: 0;
}
p {
    margin: 0;
    margin-top: 1rem;
    font-size: 1.2rem;
    line-height: 1.4rem;
    max-width: 70%;
}
.course-view {
    min-height: 100%;
    width: 100%;
    flex: 1;
    padding: 5rem 25rem;
}
.course-header {
    display: flex;
    margin-top: 1.5rem;
}
.course-description {
    flex: 3;
}
.course-details {
    /deep/ h2 {
        font-size: 1.8rem;
        margin: 0;
        margin-top: 1.5rem;
    }
    /deep/ p {
        line-height: 1.4rem;
    }
    /deep/ ul {
        padding: 0;
        list-style-type: none;
        margin: 0;
        margin-top: 1rem;

        li {
            margin-top: 0.2rem;
            &::before {
                content: '- ';
            }
        }
    }
}
@media (max-width: 1000px) {
    .title {
        font-size: 1.5rem;
        line-height: 120%;
        font-family: $input-family;
    }
    .course-details {
        /deep/ h2 {
            font-size: 1.2rem;
            font-family: $input-family;
            margin: 0;
            margin-top: 1.5rem;
        }
        /deep/ ul {
            padding: 0;
            list-style-type: none;
            margin: 0;
            margin-top: 1rem;

            li {
                margin-top: 0.2rem;
                &::before {
                    content: '\2022';
                    color: $accent-apple;
                    font-size: 40px;
                    margin-right: 0.3rem;
                    position: relative;
                    top: 0.375rem;
                }
            }
        }
    }
    .has-border-bottom {
        border-bottom: $list-border;
        margin-top: 1.5rem;
        margin-bottom: 1.5rem;
    }
    .course-view {
        flex-direction: column;
        padding: 1.5rem 2rem;
    }
    .course-header {
        flex-direction: column-reverse;
    }
    .course-description {
        margin-top: 1.5rem;
        .desc {
            font-family: $input-family;
            color: $smoked;
            line-height: 135%;
        }
    }
    .webinar-certificate-button {
        margin-left: 0;
    }
    p {
        max-width: 100%;
    }
    .button-container {
        margin: 0 -2rem;
        padding: 0 2rem;
    }
    .webinar-button-subtitle {
        text-align: center;
    }
}
</style>
